<template>
	<div class="dashboard">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Order Items Detail Report</h1>
		<div class="content-wrapper">
			<b-field label="Select Shop (required)">
				<b-autocomplete
					v-model="shopsSuggestions"
					:data="filteredShops"
					:open-on-focus="true"
					placeholder="Shop"
					field="name"
					@select="option => (selectedShop = option)"
					class="shopAutoComplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>

			<div class="single-text-wrapper">
				<b-field label="BD Code">
					<b-input v-model="bdCode" placeholder="BD Code" @keyup.native.enter="submit()"></b-input>
				</b-field>
			</div>

			<!-- <b-field label="Select Brand (optional)">
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field> -->

			<!-- <div class="datepickerWrapper">
				<b-field label="Starting Date">
					<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="startingDate" icon="calendar-today">
						<button class="button is-primary" @click="startingDate = new Date()">
							<b-icon icon="calendar-today"></b-icon>
							<span>Today</span>
						</button>

						<button class="button is-danger" @click="startingDate = null">
							<b-icon icon="close"></b-icon>
							<span>Clear</span>
						</button></b-datepicker
					>
				</b-field>

				<b-field label="Ending Date">
					<b-datepicker
						:date-formatter="dateFormatter"
						placeholder="Click to select..."
						v-model="endingDate"
						icon="calendar-today"
						:min-date="minDate"
						:max-date="maxDate"
					>
						<button class="button is-danger" @click="endingDate = null">
							<b-icon icon="close"></b-icon>
							<span>Clear</span>
						</button></b-datepicker
					>
				</b-field>
			</div> -->

			<div class="filter-button-wrapper">
				<div class="big-button" @click="getTotalStock">Total Stock</div>
			</div>

			<div class="filter-button-wrapper">
				<div class="big-button" @click="submit">SUBMIT</div>
			</div>

			<div>
				<strong>{{ status }}</strong>
			</div>
			<div v-if="orderItemsTotal"><br />Order Items {{ orderItemsTotal }}</div>
			<div v-if="orderItemsFOCTotal"><br />FOC Order Items {{ orderItemsFOCTotal }}</div>
			<div v-if="orderFOCTotal"><br />Order FOC {{ orderFOCTotal }}</div>

			<button @click="exportAll()">Export Orders</button>
			<br />
			<br />
			<button @click="stockAdjustment()">Export Stock Adjustment and Transfers</button>

			<div class="shopProductHistories" v-for="(item, key) of productHistories" :key="key">
				<div>{{ item.shop_product.stock }}</div>
				<div>{{ item.detail }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Dashboard',
	data: () => ({
		isLoading: false,
		startingDate: null,
		endingDate: null,
		minDate: null,
		maxDate: null,
		shops: [], // For list of shops from API
		shopsSuggestions: '', // For dropdown selection
		selectedShop: null, // Selected shop
		bdCode: 'BES-01602',
		orderItemsTotal: null,
		orderItemsFOCTotal: null,
		orderFOCTotal: null,
		orderItems: null,
		orderItemsFOC: null,
		orderFOC: null,
		productHistory: null,
		productTransferFrom: null,
		productTransferTo: null,
		productReturn: null,
		product: null,
		status: null,
		allOrders: [],
		productHistories: []
	}),

	watch: {
		startingDate: function(data) {
			if (data !== null) {
				this.minDate = data
				this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)

				this.endingDate = data
			} else {
				this.endingDate = null
			}
		},

		// To display or hide brand selection
		topType: function(newData) {
			if (newData == 'products') {
				this.displayBrandSelection = true
			} else {
				this.displayBrandSelection = false
			}
		}
	},

	mounted: async function() {
		await this.getShops()

		await this.getBrands()
	},

	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		},

		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		// Get all the brands
		getBrands: async function() {
			const data = {
				limit: 1000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				this.brands = apiGetBrands.data.list
			}
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		},

		getTotalStock: async function() {
			let data = {
				bd_code: this.bdCode
			}

			const product = await this.$api.getProductDetail({ data })

			// data = {
			// 	shop: this.selectedShop._id,
			// 	product: product.data._id
			// }

			// const shopProduct = await this.$api.shopProduct({ data })

			data = {
				shop_product: {
					shop: this.selectedShop._id,
					product: product.data._id
				},
				limit: 0,
				sort: {
					createdAt: 'asc'
				}
			}

			const shopProductHistory = await this.$api.shopProductHistory({ data })

			if (shopProductHistory) {
				this.productHistories = shopProductHistory.data.list
			}
		},

		submit: async function() {
			this.orderItemsTotal = null
			this.orderItemsFOCTotal = null
			this.orderItemsFOC = null
			this.orderFOC = null
			this.orderItems = null
			this.orderItemsFOC = null
			this.allOrders = []

			// if (this.selectedShop == null) {
			// 	this.$swal.fire('error', 'Shop is required', 'error')
			// 	return
			// }

			this.isLoading = true

			var data = {}
			const createdAt = {}

			if (this.startingDate !== null) {
				createdAt['$gte'] = this.$moment(this.startingDate)
					.set({ hour: 0 })
					.format('x')
			}

			if (this.endingDate !== null) {
				createdAt['$lte'] = this.$moment(this.endingDate)
					.set({ hour: 24 })
					.format('x')
			}

			data = {
				bd_code: this.bdCode
			}

			const product = await this.$api.getProductDetail({ data })

			this.product = product.data

			if (!product) {
				return
			}

			// -------------------------------------------------------------

			this.status = 'Getting order items'

			// For getting total value of sales
			data = {
				pay_status: 1,
				// order_items: {
				product: product.data._id
				// }
				// time: {
				// 	createdAt
				// }
			}

			if (this.selectedShop) {
				data.shop = this.selectedShop._id
			}

			// First get all from order items
			this.orderItems = await this.$api.orderItemList({ data })

			// -------------------------------------------------------------

			this.status = 'Getting order items FOC'

			data = {
				// pay_status: 1,
				// order_items: {
				promotions: product.data._id,
				populate: ['order'],
				limit: 0
				// }
				// time: {
				// 	createdAt
				// }
			}

			if (this.selectedShop) {
				data.shop = this.selectedShop._id
			}

			// Second get order item FOC products
			this.orderItemsFOC = await this.$api.orderItemList({ data })

			// -------------------------------------------------------------

			this.status = 'Getting orders FOC'

			data = {
				pay_status: 1,
				promotions: product.data._id,
				limit: 0
				// time: {
				// 	createdAt
				// }
			}

			if (this.selectedShop) {
				data.shop = this.selectedShop._id
			}

			// Third, get order FOC products
			this.orderFOC = await this.$api.getOrders({ data })

			// -------------------------------------------------------------

			data = {
				limit: 0,
				shop_product: {
					product: product.data._id
				},
				sort: {
					createdAt: 'asc'
				}
				// time: {
				// 	createdAt
				// }
			}

			if (this.selectedShop && this.selectedShop._id) {
				data.shop_product.shop = this.selectedShop._id
			}

			this.productHistory = await this.$api.shopProductHistory({ data })

			// -------------------------------------------------------------

			// Get product transfer list FROM
			data = {
				limit: 0,
				operations: {
					product: product.data._id
				},
				sort: {
					createdAt: 'asc'
				}
				// time: {
				// 	createdAt
				// }
			}

			if (this.selectedShop && this.selectedShop._id) {
				data.shop_from = this.selectedShop._id
			}

			this.productTransferFrom = await this.$api.getShopProductTransfer({ data })

			data = {
				limit: 0,
				operations: {
					product: product.data._id
				},
				sort: {
					createdAt: 'asc'
				}
				// time: {
				// 	createdAt
				// }
			}

			if (this.selectedShop && this.selectedShop._id) {
				data.shop_to = this.selectedShop._id
			}

			this.productTransferTo = await this.$api.getShopProductTransfer({ data })

			// -------------------------------------------------------------

			// Get product transfer return
			data = {
				limit: 0,
				product: product.data._id,
				populate: ['return_product'],
				sort: {
					createdAt: 'asc'
				}
				// time: {
				// 	createdAt
				// }
			}

			if (this.selectedShop && this.selectedShop._id) {
				data.shop = this.selectedShop._id
			}

			this.productReturn = await this.$api.getReturnProductItems({ data })

			console.log(this.productReturn)

			// -------------------------------------------------------------

			if (this.orderItems && this.orderItems.data.list.length > 0) {
				this.orderItemsTotal = 0

				this.orderItems.data.list.map(order_items => {
					if (order_items.order.pay_status == 1) {
						this.orderItemsTotal += order_items.qty
					}
				})
			}

			if (this.orderItemsFOC && this.orderItemsFOC.data.list.length > 0) {
				this.orderItemsFOCTotal = 0
				this.orderItemsFOC.data.list.map(order_items => {
					if (order_items.order.pay_status == 1) {
						order_items.promotions.map(promotions => {
							promotions.options.products.map(products => {
								if (products == product.data._id) {
									this.orderItemsFOCTotal++
								}
							})
						})
					}
				})
			}

			if (this.orderFOC && this.orderFOC.data.list.length > 0) {
				this.orderFOCTotal = 0
				this.orderFOC.data.list.map(orders => {
					orders.promotions.map(promotions => {
						promotions.options.products.map(products => {
							if (products == product.data._id) {
								this.orderFOCTotal++
							}
						})
					})
				})
			}

			this.isLoading = false

			this.status = 'Finished'
		},

		exportOrderItems: async function() {
			for (const item of this.orderItems.data.list) {
				const order = item.order
				const product = this.product

				const orders = {
					date: this.$moment(order.updatedAt).format('DD/MM/YYYY'), // Date
					time: this.$moment(order.updatedAt).format('HH:mm'), // Time
					orderAlias: order.alias, // Order ID
					bdCode: product.bd_code, // BD Code
					barcode: '"' + product.barcode + '"', // Barcode
					name: '"' + product.name + '"', // Product Name
					total: item.qty,
					foc: null,
					updatedAt: order.updatedAt
				}

				this.allOrders.push(orders)
			}
		},

		exportOrderItemsFOC: async function() {
			for (const item of this.orderItemsFOC.data.list) {
				let totalItems = 0

				if (item.order.pay_status == 1) {
					item.promotions.map(promotions => {
						promotions.options.products.map(products => {
							if (products == this.product._id) {
								totalItems++
								// totalItems++
							}
						})
					})
				}

				const order = item.order
				const product = this.product

				const orders = {
					date: this.$moment(order.updatedAt).format('DD/MM/YYYY'), // Date
					time: this.$moment(order.updatedAt).format('HH:mm'), // Time
					orderAlias: order.alias, // Order ID
					bdCode: product.bd_code, // BD Code
					barcode: '"' + product.barcode + '"', // Barcode
					name: '"' + product.name + '"', // Product Name
					total: null,
					foc: totalItems,
					updatedAt: order.updatedAt
				}

				this.allOrders.push(orders)
			}
		},

		exportOrderFOC: async function() {
			for (const order of this.orderFOC.data.list) {
				let totalItems = 0

				order.promotions.map(promotions => {
					promotions.options.products.map(products => {
						if (products == this.product._id) {
							totalItems++
						}
					})
				})

				const product = this.product

				const orders = {
					date: this.$moment(order.updatedAt).format('DD/MM/YYYY'), // Date
					time: this.$moment(order.updatedAt).format('HH:mm'), // Time
					orderAlias: order.alias, // Order ID
					bdCode: product.bd_code, // BD Code
					barcode: '"' + product.barcode + '"', // Barcode
					name: '"' + product.name + '"', // Product Name
					total: null,
					foc: totalItems,
					updatedAt: order.updatedAt
				}

				this.allOrders.push(orders)
			}
		},

		stockAdjustment: async function() {
			let prev_desc = ''
			let prev_stock = ''
			// let prev_type = ''

			if (this.productHistory && this.productHistory.data && this.productHistory.data.count > 0) {
				this.productHistory.data.list.map(item => {
					const type = item.type
					const desc = item.shop_product.description ? item.shop_product.description : ''
					const stock = item.shop_product.stock

					if (desc !== prev_desc && stock !== prev_stock) {
						console.log('stock adjustment', type, desc, stock - prev_stock, item)
					}

					// prev_type = type
					prev_desc = desc
					prev_stock = stock
				})
			}
		},

		exportAll: async function() {
			await this.exportOrderItems()
			await this.exportOrderItemsFOC()
			await this.exportOrderFOC()

			await this.allOrders.sort((a, b) => (a.updatedAt > b.updatedAt ? 1 : b.updatedAt > a.updatedAt ? -1 : 0))

			let export_csv = 'DATE,TIME,ORDER ID,BD CODE,BARCODE,PRODUCT,TOTAL ITEMS SOLD,FOC\r\n'

			this.allOrders.map(order => {
				const toAdd = [
					order.date, // Date
					order.time, // Time
					order.orderAlias, // Order ID
					order.bdCode, // BD Code
					'"' + order.barcode + '"', // Barcode
					'"' + order.name + '"', // Product Name
					order.total,
					order.foc
				] // Net Amount

				const row = toAdd.join(',')

				export_csv += row + '\r\n'
			})

			let filename_date = this.$moment().format('DDMMYYhhmmss')

			var csvData = new Blob([export_csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'Order Items Report ' + filename_date + '.csv')
			document.body.appendChild(link) // Required for FF

			// link.click()
			link.remove()
		},

		compare: (a, b) => {
			console.log(a, b)
			if (a.updatedAt > b.updatedAt) return 1

			if (b.updatedAt > a.updatedAt) return -1

			return 0
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
